import { useCallback, useEffect, useState } from "react";

/**
 * The prototype's toast: one line that states the outcome and the event
 * recorded, gone after 2.6 seconds (docs/UX.md section 6).
 */
export function useToast(): { toast: (message: string) => void; Toast: () => JSX.Element | null } {
  const [message, setMessage] = useState<string | null>(null);
  useEffect(() => {
    if (message === null) return;
    const timer = setTimeout(() => setMessage(null), 2600);
    return () => clearTimeout(timer);
  }, [message]);
  const toast = useCallback((m: string) => setMessage(m), []);
  const Toast = useCallback(
    () =>
      message ? (
        <div className="toast" role="status">
          {message}
        </div>
      ) : null,
    [message],
  );
  return { toast, Toast };
}
